import { render, staticRenderFns } from "./RI.vue?vue&type=template&id=1900d4f6&"
import script from "./RI.vue?vue&type=script&lang=ts&"
export * from "./RI.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports